<td>
  <service-icon size="s" [type]="productTypeName()" />
</td>
<td>
  <div class="minl-table__link" (click)="routeToService()">
    {{ description() }}
  </div>
</td>
<td>{{ presentableName() }}</td>
<td style="width: 400px">
  <div class="save-wrapper">
    <div [hidden]="!inProgress()">
      <svg-icon class="save-icon green" src="assets/images/icons/ok.svg"></svg-icon>
    </div>
    <div class="select-wrapper">
      <select
        [disabled]="!isInfraverantwoordelijke()"
        name="notification"
        [ngModel]="impactSetting()"
        (ngModelChange)="impactTypeChanged($event)"
      >
        <option value="Never">{{ "Notification.Status.Never" | translate }}</option>
        <option value="Downtime">{{ "Notification.Status.Downtime" | translate }}</option>
        <option value="Loss of Resiliency">
          {{ "Notification.Status.LossofResiliency" | translate }}
        </option>
        <option value="Reduced Redundancy">
          {{ "Notification.Status.ReducedRedundancy" | translate }}
        </option>
      </select>
      <svg-icon src="assets/images/icons/select-arrows.svg"></svg-icon>
    </div>
  </div>
</td>
